export default {
      id: "playNextStep-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#playNextStep-usage",
      toString: function () {
        return this.url;
      }
    }